import React, {useState, useEffect} from 'react';
import Modal from 'react-bootstrap/Modal';
import { useHistory, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import { Loading } from '~/components';
import { FormCad } from '../components';
import initialData from './initialData';
import schema from './schema'
import { Button } from 'react-bootstrap';
import { updateTipoLicenca, showTipoLicenca, loadTipoLicencas } from '~/store/modules/tipo_licenca/action';



const Edit = ({ currentPage }) => {
  let history = useHistory();
  const [TipoLicencaEdit, setTipoLicencaEdit] = useState(initialData);
  const [errorsValidate, setErrorsValidate] = useState([]);
  const [updated, setUpdated] = useState(false);
  const dispatch = useDispatch();
  const { atividade_id, tipo_licenca_id } = useParams();
  const { tipo_licenca, errors } = useSelector(({ TipoLicencaReducer }) => TipoLicencaReducer);

  useEffect(() => {
    dispatch(showTipoLicenca(tipo_licenca_id, {
      with_trash: true
    }));
  }, [dispatch, tipo_licenca_id]);

  useEffect(() => {
    if (tipo_licenca.id === parseInt(tipo_licenca_id)) {
      setTipoLicencaEdit(tipo_licenca);
    }
  }, [tipo_licenca, tipo_licenca_id]);

  useEffect(() => {
    if (errors.status && errors.status === 422) {
      let server_errors = {};
      const response_errors = errors.data.errors;
      for (let name of Object.keys(response_errors)) {
        Object.assign(server_errors, { [name]: response_errors[name][0] });
      }
      setErrorsValidate(server_errors);
    }
    if(errors.update) {
      setUpdated(true);
    }
  }, [errors]);

  useEffect(() => {
    if (updated) {
      Swal.fire('Sucesso', 'Registro atualizado com sucesso!', 'success').then(
        () => {
          history.goBack();
          dispatch(dispatch(loadTipoLicencas({
            where:`atividade_id:${atividade_id}`,
            page: currentPage
          })));
        }
      );
    }
  }, [updated, history, dispatch, atividade_id, currentPage]);

  const handleClose = () => {
    history.goBack('/tipo_licenca');
  };

  const handleSubmit = async event => {
    event.preventDefault();
    if (!schema.isValidSync(TipoLicencaEdit)) {
      let yup_errors = {};
      schema.validate(TipoLicencaEdit, { abortEarly: false }).catch(err => {
        for (let error of err.inner) {
          const { path, message } = error;
          Object.assign(yup_errors, { [path]: message });
        }
        setErrorsValidate(yup_errors);
      });
    } else {
      await dispatch(updateTipoLicenca(TipoLicencaEdit, tipo_licenca_id));
    }
  };
  return (
    <Modal
      aria-labelledby="contained-modal-title-vcenter"
      dialogClassName="modal-xl"
      onHide={handleClose}
      show
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">Tipo Licenca</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="card">
          <div className="card-header">
            <h2 className="card-title">Editar</h2>
          </div>
          <div className="card-body">
            {tipo_licenca.id === parseInt(tipo_licenca_id) ? (
              <FormCad
                errors={errorsValidate}
                handleSubmit={handleSubmit}
                schema={schema}
                setTipoLicenca={setTipoLicencaEdit}
                tipo_licenca={TipoLicencaEdit}
              />
            ) : (
              <Loading />
            )}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          className="btn btn-default"
          onClick={handleClose}
        >
          <i className="fa fa-window-close" /> Cancelar
        </Button>
        <button
          className="btn btn-success"
          form="form_tipo_licenca"
          type="submint"
        >
          <i className="fa fa-save" /> Salvar
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default Edit;
